/*
* Project: LegalPlace assistant
* File: src/components/modal.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PreviewRow from './preview_row';
import { generateId1 } from './utils/misc';
// import actions
import { togglePreview } from '../redux/actions/toggle_preview';
import lpApp from '../app/lp_app';
import { ConditionRuntime } from '../logic/condition_tree';
import ConditionsEvo from '../logic/condition_evo';

let numberOfAll = 0;

// calculation of page numbers
const PAGE_WIDTH = 684;

function getPageNumber(width) {
  return Math.ceil(width / PAGE_WIDTH);
}

// ██████╗ ██████╗ ███████╗██████╗  █████╗ ██████╗ ███████╗    ██████╗  ██████╗ ███╗   ███╗
// ██╔══██╗██╔══██╗██╔════╝██╔══██╗██╔══██╗██╔══██╗██╔════╝    ██╔══██╗██╔═══██╗████╗ ████║
// ██████╔╝██████╔╝█████╗  ██████╔╝███████║██████╔╝█████╗      ██║  ██║██║   ██║██╔████╔██║
// ██╔═══╝ ██╔══██╗██╔══╝  ██╔═══╝ ██╔══██║██╔══██╗██╔══╝      ██║  ██║██║   ██║██║╚██╔╝██║
// ██║     ██║  ██║███████╗██║     ██║  ██║██║  ██║███████╗    ██████╔╝╚██████╔╝██║ ╚═╝ ██║
// ╚═╝     ╚═╝  ╚═╝╚══════╝╚═╝     ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝    ╚═════╝  ╚═════╝ ╚═╝     ╚═╝
//

class _PreviewModal extends Component {
  constructor(props) {
    super(props);
    this.len = 0;
    this.state = {
      page_length: 0,
    };
  }

  componentDidMount() {
  }

  componentWillUpdate(nextProps, nextState) {
    window.modal = this.refs.modal_doc;
    window.c_page = this.refs.current_page;
    window.t_page = this.refs.total_page;
    if (this.refs.modal_doc) {
      const pageNumber = getPageNumber(this.refs.modal_doc.scrollWidth);
      nextState.page_length = pageNumber; // eslint-disable-line
    }
  }

  componentDidUpdate() {
    // show and hide the page number

    if (this.refs.modal_doc) {
      const pageNumber = getPageNumber(this.refs.modal_doc.scrollWidth);
      this.state.page_length = pageNumber;
      if (this.refs.total_page) this.refs.total_page.innerText = ` ${pageNumber}`;
    }
    const nbrSys = {};
    // this one must change
    const numbers = document.querySelectorAll('[num-auto], [num-auto-pre]');
    // get the numbering system

    // console.log(numbers);
    for (let i = 0; i < numbers.length; i += 1) {
      const v = numbers[i];
      if (v && v.attributes && v.attributes.getNamedItem('num-auto')) {
        nbrSys[v.attributes.getNamedItem('num-auto').value] = 0;
      } else {
        nbrSys[v.attributes.getNamedItem('num-auto-pre').value] = 0;
      }
    }

    Object.keys(numbers).forEach((idx) => {
      const element = numbers[idx];
      if (element && element.attributes && element.attributes.getNamedItem('num-auto')) {
        const counter = element.attributes.getNamedItem('num-auto').value;
        nbrSys[counter] += 1;
        element.innerHTML = nbrSys[counter];
        // test if it's an article
        if (counter === 'articles') {
          // init all them
          Object.keys(nbrSys).forEach((index) => {
            if (index !== 'articles') nbrSys[index] = 0;
          });
        }
      } else if (element && element.attributes) {
        const counter = element.attributes.getNamedItem('num-auto-pre').value;
        element.innerHTML = nbrSys[counter];
      }
    });
  }

  render() {
    // console.time('modal')

    if (this.props.canBeGenerated && this.props.isFDF) {
      return (
        // To match worker legacy behaviour not actually angular
        <pre id="FDFJson" ng-if="contractCtrl.disable_preview" class="ng-binding ng-scope">
          {this.props.FDFOutput}
        </pre>
      )
    }
    return (
      <div
        id="doc-preview"
        ref="exit_yo"
      >
        <div ref="modal_doc">
          <div className="page">
            {'PAGE_BEGIN_PRERENDER'}
            {this.props.canBeGenerated && this.props.views.map(idx => (
              <PreviewRow
                key={generateId1(4)}
                idOut={idx[1]}
                out={idx[0]}
              />
            ))}
            {!this.props.canBeGenerated && 'LP_PRERENDER_DO_NOT_GENERATE'}
            {'PAGE_END_PRERENDER'}
          </div>
        </div>
      </div>
    );
    // console.timeEnd('modal')
  }
}


const mapStateToProps = (state) => {
  let isFDF = false
  let FDFOutput = ''
  // check the updatable conditions.
  numberOfAll = 0;
  const outputs = [];
  // The algorithm of grabbing the
  // get the section content
  // prepare options
  if (!state.contract) {
    return {
      views: [],
    };
  }
  // TODO: work on
  const keys = lpApp.references.sections;

  // console.log(keys)
  if(keys) {
    keys.map((idx) => {
        if(idx.compiledConditions && idx.compiledConditions.length > 0)
            if(!ConditionsEvo.rawCondition(idx.compiledConditions))
                return false;
        lpApp.ops.content.getOutput(idx.options, outputs);
    });
  }
  lpApp.indexes.content.updateContent(outputs, numberOfAll);
  // console.log("Hello")

  // Checking if the document can be generated
  let canBeGenerated = true;
  if (typeof (lpApp.prerenderDoc) === 'number' && !Number.isNaN(lpApp.prerenderDoc)) {
    const docsConditions = lpApp.ops.document.checkWrappers();
    if (Object.prototype.hasOwnProperty.call(docsConditions, lpApp.prerenderDoc)) {
      canBeGenerated = (docsConditions[lpApp.prerenderDoc].cond === true);
    } else {
      canBeGenerated = false;
    }
  }

  // Use old prerender behavior
  if (typeof lpApp.prerenderDoc === 'number') {
    const document = lpApp.references.docs_wrappers[lpApp.prerenderDoc]
    isFDF = Object.keys(document.linked_pdf) > 0
    if (isFDF) {
      const linkedPdf = document.linked_pdf
      FDFOutput = `{"FDFJson":{},"PDFId":"${linkedPdf.pdfId}"}`
    }
  }

  return {
    preview: state.preview,
    views: outputs,
    is_modal: state.preview,
    canBeGenerated,
    isFDF,
    FDFOutput,
  };
};

const mapDispatchToProps = dispatch => ({
  toggle_screen: () => {
    dispatch(togglePreview());
  },
});

const PreviewModal = connect(mapStateToProps, mapDispatchToProps)(_PreviewModal);

export default PreviewModal;



// WEBPACK FOOTER //
// ./src/components/prerender.js